<template>
  <v-card class="mx-auto">
    <v-card-text>
      <v-data-table dense :headers="headers" :items="items">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-2 text--primary">{{ title }}</v-toolbar-title>
          </v-toolbar>
          <v-dialog v-model="userDialog" width="400">
            <v-card>
              <v-card-title class="text-h6"> Account viewed the file: </v-card-title>
              <v-card-text>
                <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-0"></v-progress-linear>
                <v-simple-table v-if="!loading">
                  <template v-slot:default>
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(item, index) in userViewed" :key="item.user || index">
                        <v-expansion-panel-header>
                          {{ item.user }}
                          <span class="text-right">Viewed({{ item.viewed }})</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div
                            class="d-flex justify-space-between"
                            v-for="(detail, index) in item.details"
                            :key="detail.time_enter || index"
                          >
                            <span>Viewed({{ index + 1 }})</span>
                            <span>{{ displayLocalDate(detail.time_enter + "Z") }}</span>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn small text @click="userDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ displayLocalDate(item.created_at) }}
        </template>
        <template v-slot:[`item.user_view`]="{ item }">
          <v-chip small :color="getColor(item.user_view)" text-color="white" @click="getUsers(item)">
            viewed ({{ item.user_view ? item.user_view : 0 }})
          </v-chip>
        </template>
        <template v-slot:no-data> No Policy subGroup urls found. </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { format, utcToZonedTime } from "date-fns-tz";

export default {
  name: "PolicySubgroupDocumentUrlsLog",
  props: {
    items: Array,
    title: String,
    userViewed: Array,
    loading: Boolean
  },
  data() {
    return {
      headers: [
        { text: "URLs", value: "file_name", align: "start" },
        // { text: "Group code", value: "group_code", align: "left" },
        // { text: "Plan", value: "plan", align: "left" },
        { text: "Uploaded Date/time", value: "created_at", align: "left" },
        {
          text: "",
          value: "user_view",
          align: "right",
          sortable: false
        }
      ],
      userDialog: false
    };
  },
  watch: {},
  methods: {
    getColor(view) {
      return view ? "green" : "grey lighten-1";
    },
    getUsers(resource) {
      if (!resource.user_view) {
        return;
      }

      this.$emit("getUsers", {
        fileName: resource.file_name,
        policyId: resource.policy_id,
        section: this.title,
        subGroup: {
          groupCode: resource.group_code,
          plan: resource.plan
        },
        resourceId: resource.resource_id
      });

      this.userDialog = true;
    },
    displayLocalDate(date) {
      if (date) {
        const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const zonedDate = utcToZonedTime(new Date(date), localTimeZone);
        return format(zonedDate, "yyyy-MM-dd (HH:mm:ss)");
      }
      return "";
    }
  }
};
</script>

<style>
.capitalize {
  text-transform: capitalize;
}
</style>
